import React from 'react';

const CLAIMS = [
	{
		key: 'creators',
		label: '80% to creators',
		icon: (
			<svg width={21} height={21} viewBox="0 0 22 22">
				<g fill="none" stroke="#111" strokeWidth={1.9} strokeLinecap="round">
					<path d="M8 5 C8 2.8 14 2.8 14 5 L13 7 H9 Z" />
					<path d="M9 7 C4 10 3.5 19 11 19 C18.5 19 18 10 13 7" />
					<path d="M9.5 12.5 c0-1.5 3-1.5 3 0 s-3 1.5-3 3 3 1.5 3 0 M11 10.8 v6.4" strokeWidth={1.5} />
				</g>
			</svg>
		),
	},
	{
		key: 'airdrop',
		label: 'Airdrop for traders',
		icon: (
			<svg width={21} height={21} viewBox="0 0 22 22">
				<g fill="none" stroke="#111" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
					<path d="M3 9 C3 4 19 4 19 9 M3 9 L8 8 L11 9 L14 8 L19 9 M3 9 L10 16 M19 9 L12 16 M8 8 L10 16 M14 8 L12 16" />
					<rect x="9.5" y="16" width="3" height="3.5" />
				</g>
			</svg>
		),
	},
	{
		key: 'burn',
		label: 'BuyBack & Burn of Official token',
		icon: (
			<svg width={21} height={21} viewBox="0 0 22 22">
				<g fill="none" stroke="#111" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
					<path d="M11 3 C11 7 6 8 6 13 a5 5 0 0 0 10 0 C16 9 11 8 11 3 Z" />
					<path d="M9 14 a2 2 0 0 0 4 0 c0-1.5-2-2-2-3.5" />
				</g>
			</svg>
		),
	},
];

export const InfoBar = () => {
	const [rotateIndex, setRotateIndex] = React.useState(0);

	React.useEffect(() => {
		const timer = setInterval(() => {
			setRotateIndex((prev) => (prev + 1) % CLAIMS.length);
		}, 3000);
		return () => clearInterval(timer);
	}, []);

	return (
		<div className={`pf-infobar pf-ir${rotateIndex}`} style={{
			display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-around',
			gap: '18px', borderBottom: '3px solid var(--color-carbon)',
			background: 'var(--accent)', padding: '12px 20px 12px 62px',
			fontFamily: 'var(--font-sans)', fontSize: '18px', fontWeight: 600,
			letterSpacing: '0.2px', color: 'var(--color-carbon)',
		}}>
			{CLAIMS.map((claim) => (
				<span key={claim.key} className="pf-shake" style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
					{claim.icon}
					{claim.label}
				</span>
			))}
		</div>
	);
};
